module.exports = __webpack_public_path__ + "media/images/product_large_images/cashdrawer-36abc2edd3a2f8cb537d67571036b08c.png";